import { createContext, useContext } from 'react'
import type { Langue } from '@tb/shared'
/** Les composants d’interface restent utilisables seuls, sans requête réseau.
 * La coque publique fournit la préférence du visiteur ; celle du personnel
 * fournit la langue de la maison. Le défaut des composants isolés est français. */
export const ContexteLangueInterface = createContext<Langue>('fr')
export function useLangueInterface(): Langue {
  return useContext(ContexteLangueInterface)
}
